import type { PumpStatus } from "@tandemdiabetes/sugarmate-api-react-client"
import classNames from "classnames"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { forwardRef } from "react"

import styles from "./PumpStatus.module.scss"

import {
  useDisplayTime,
  useIsPumpStatusSensorNearlyExpired,
} from "src/hooks"

export interface Props extends ComponentPropsWithoutRef<"div"> {
  pumpStatus: PumpStatus;
  isSensorExpirationStale: boolean;
}

export const PumpSensorExpirationTime = forwardRef<HTMLDivElement, Props>(
  function PumpSensorExpirationTime(props: Props, propRef: Ref<HTMLDivElement>) {
    const {
      pumpStatus,
      isSensorExpirationStale,
      ...divProps
    } = props

    const { sensor_expiration: sensorExpiration } = pumpStatus
    const isSensorNearlyExpired = useIsPumpStatusSensorNearlyExpired(pumpStatus)


    const displayTime = useDisplayTime()
    const sensorExpirationTime = sensorExpiration === null || isSensorExpirationStale
      ? "---"
      : displayTime(sensorExpiration)

    return (
      <div
        {...divProps}
        className={classNames(
          divProps.className,
          isSensorNearlyExpired && !isSensorExpirationStale && styles.expiringText,
        )}
        ref={propRef}
      >
        {sensorExpirationTime}
      </div>
    )
  },
)
